var storefrontApp = angular.module("storefrontApp");
//#region Home Service
storefrontApp.service("productService", [
    "$http",
    function ($http) {
        return {
            getPatchesCategories: function () {
                return $http.get("storefrontapi/getfabriccategories");
            },
            isPatchEligible: function (productId) {
                return $http.get(
                    "storefrontapi/ispatchconversioneligible?productId=" +
                        productId
                );
            },
            getPatchContent: function () {
                return $http.get("storefrontapi/patchcontent");
            },
            getProductRelatedProjects: function (productId) {
                return $http.get(
                    "storefrontapi/learningcenter/getproductprojects?itemId=" +
                        productId
                );
            },
            getProjectPDFUrl: function (projectId) {
                return $http.get(
                    "storefrontapi/learningcenter/projectpdfurlbyid?projId=" +
                        projectId
                );
            },
            isColorChartAvailable: function (fileSubpath, fileType) {
                return $http.get(
                    "storefrontapi/isFileAvailable?fileSubpath=" +
                        fileSubpath +
                        "&fileType=" +
                        fileType
                );
            },
            submitLowerPriceRequest: function (lowerPrice) {
                return $http.post(
                    "storefrontapi/contact/lowerprice",
                    lowerPrice
                );
            },
            getInspirationImages: function (productId, definition, brand) {
                return $http.get(
                    "storefrontapi/inspirations?productId=" +
                        productId +
                        "&definition=" +
                        definition +
                        "&brand=" +
                        brand
                );
            },
            checkProductVideosExists: function (productId, brand) {
                return $http.get(
                    "storefrontapi/checkproductvideosexists?productId=" +
                        productId +
                        "&brand=" +
                        brand
                );
            },
            getThreadMfgByCatalog: function (catalogId) {
                return $http.get(
                    "storefrontapi/threadmfgbycatalog?catalogId=" + catalogId
                );
            },
            getThreadConverterColorChart: function (
                colorCodes,
                threadMfg,
                isProductPage
            ) {
                if (colorCodes != null && colorCodes.length > 0) {
                    var requestData = {
                        ColorCodes: colorCodes,
                        ThreadMfg: threadMfg,
                        IsProductPage: isProductPage,
                    };
                    return $http.post(
                        "storefrontapi/threadconvertercolorchart",
                        requestData
                    );
                } else {
                    return null;
                }
            },
            getReviewsByProductId: function (productId, count) {
                if (angular.isDefined(count) && count > 0) {
                    return $http.get(
                        "storefrontapi/getreviewsbyproductid?productId=" +
                            productId +
                            "&isEcomStore=true" +
                            "&count=" +
                            count
                    );
                } else {
                    return $http.get(
                        "storefrontapi/getreviewsbyproductid?productId=" +
                            productId +
                            "&isEcomStore=true"
                    );
                }
            },
            getCopyrightsByProductIds: function (productIds) {
                var url = "storefrontapi/products/copyrights?";
                productIds.forEach(function (item, index) {
                    if (index == 1) {
                        url = url.concat("productIds=", item);
                    } else {
                        url = url.concat("&productIds=", item);
                    }
                });
                return $http.get(url);
            },
            getProductsInventory: function (productId) {
                return $http.get(
                    "storefrontapi/product/inventories?t=" +
                        new Date().getTime(),
                    { params: { productIds: productId } }
                );
            },
            getResellableArtists: function (productId) {
                return $http.get("storefrontapi/getresellableartists");
            },
            getThreadMfgByCatalog: function (catalogId) {
                return $http.get(
                    "storefrontapi/threadmfgbycatalog?catalogId=" +
                        catalogId +
                        "&t=" +
                        new Date().getTime()
                );
            },
            getThreadColorCodeFromSequence: function (colorSequence) {
                colorSequence = colorSequence || "";
                return colorSequence.indexOf("(") !== -1 &&
                    colorSequence.indexOf(")") !== -1
                    ? colorSequence.substring(
                          colorSequence.indexOf("(") + 1,
                          colorSequence.indexOf(")")
                      )
                    : colorSequence
                          .substring(colorSequence.indexOf(".") + 1)
                          .trim();
            },
            getThreadColorSequenceArray: function (delimitedColorSequence) {
                delimitedColorSequence = delimitedColorSequence || "";
                return _.compact(
                    delimitedColorSequence.indexOf("~^~^") == -1
                        ? delimitedColorSequence.split("~^")
                        : delimitedColorSequence.split("~^~^")
                );
            },
            getTopFiveProducts: function (topProductsRequest) {
                return $http.post(
                    "storefrontapi/product/gettopproducts",
                    topProductsRequest
                );
            },
            isProductInStock: function (productId) {
                return $http.get(
                    "storefrontapi/product/inventory/" +
                        productId +
                        "?t=" +
                        new Date().getTime()
                );
            },
            isfreeShippable: function (productId, catalog) {
                return $http.get(
                    "storefrontapi/shipping/freeshipping?productId=" +
                        productId +
                        "&catalog=" +
                        catalog
                );
            },
            getShippingEstimate: function (shippingInformation) {
                return $http.post(
                    "storefrontapi/shipping/estimate",
                    shippingInformation
                );
            },
            hasInventory: function (productId) {
                return $http.get(
                    "storefrontapi/product/inventory/" + productId
                );
            },
            sendEmailOnReferProduct: function (formData) {
                return $http.post("storefrontapi/product/refer", formData, {
                    headers: { "Content-Type": undefined },
                });
            },
            insertNotifyInStock: function (queue) {
                return $http.post("storefrontapi/insertnotifyinstock", queue);
            },
            getSaleitemkeyfeatures: function (productId) {
                return $http.get(
                    "storefrontapi/product/getsaleitemfeatures?itemId=" +
                        productId
                );
            },
            getRelatedSales: function (productId) {
                return $http.get(
                    "storefrontapi/getrelatedsales?itemId=" + productId
                );
            },
            getComboSaleSettings: function (
                productId,
                definitionName,
                vendorId,
                variants
            ) {
                return $http.post(
                    "storefrontapi/product/getcombosalesettings",
                    {
                        itemId: productId,
                        definitionName: definitionName,
                        catalogId: vendorId,
                        variants: variants,
                    }
                );
            },
            getFrequentlyBoughtProducts: function (itemId, catalog) {
                return $http.get(
                    "storefrontapi/getboughttogetheritems?itemId=" +
                        itemId +
                        "&vendor=" +
                        catalog
                );
            },
            getActiveCouponSales: function () {
                return $http.get("storefrontapi/promotions/activecoupons");
            },
        };
    },
]);
